// @flow
import React from 'react';
import { Button, ButtonGroup, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { MobileCancelMajor } from '@shopify/polaris-icons';

import BannerOffer from './banner-offer';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { URL } from 'src/constants/links';
import { turboCampaignEnd } from 'src/helpers/whitelist';
import CustomModal from 'src/components/views/common/custom-modal';

type Props = {
  active: boolean,
  onCancel: () => void
};

export const KEY_BOOST_TURBO_MODAL = 'already-close-modal-boost-turbo';

type ComposedProps = Props & WithI18nProps;

const TurboModal: React.FC<ComposedProps> = ({ i18n, active, onCancel }) => {
  const handleOpenGuide = () => {
    window.open(URL['NewVersionTurbo'], '_blank');
  };

  const handleGoToSI = () => {
    onCancel();
    history.push(routes.shopifyIntegration.view());
  };

  return (
    <CustomModal
      id="modal-turbo"
      open={active}
      className="custom-modal custom-modal--turbo-campaign"
      clickBackdrop={onCancel}>
      <div className="Polaris-Modal-Header">
        <div className="Polaris-Modal-Header__Title">
          <h2 className="Polaris-DisplayText Polaris-DisplayText--sizeSmall">
            {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.title')}
          </h2>
        </div>
        <button className="Polaris-Modal-CloseButton" onClick={onCancel}>
          <Icon source={MobileCancelMajor} color="subdued" />
        </button>
      </div>
      <div className="modal-former-upgrade-turbo">
        <BannerOffer />

        <div>
          <p>{i18n.translate('AdminHTML.Common.WarningTurbo.Modal.followGuide')}</p>
        </div>

        <div className="how-to-upgrade-box">
          <p style={{ fontWeight: 600, fontSize: '16px', marginBottom: '8px' }}>
            {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo')}
          </p>

          <ol className="how-to-upgrade__list">
            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo_Desc1', {
                  t1: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo_Desc1_t1'
                      )}
                    </b>
                  ),
                  t2: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo_Desc1_t2'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>
            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo_Desc2', {
                  t: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo_Desc2_t'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>

            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo_Desc3', {
                  date: <b>{turboCampaignEnd.format('MMM D')}</b>,
                  t: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningTurbo.Modal.howToUpgradeTurbo_Desc3_t'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>
          </ol>
        </div>

        <div>
          <p style={{ fontWeight: 600 }}>
            {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.noteTitle')}
          </p>
          <p style={{ fontWeight: 600 }}>
            {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.noteDesc1')}
          </p>
          <p>{i18n.translate('AdminHTML.Common.WarningTurbo.Modal.noteDesc2')}</p>
        </div>
      </div>

      <div className="Polaris-Modal-Footer">
        <ButtonGroup>
          <Button onClick={handleOpenGuide} accessibilityLabel="What's new in Shopify Integration">
            {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.whatsNewSI')}
          </Button>
          <Button primary onClick={handleGoToSI} accessibilityLabel="Go to Shopify Integration">
            {i18n.translate('AdminHTML.Common.WarningTurbo.Modal.goToShopifyIntegration')}
          </Button>
        </ButtonGroup>
      </div>
    </CustomModal>
  );
};

export default withI18n()(TurboModal);
